import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@webapp/auth/services/auth.service';
import { UserPoliciesStoreService } from '@webapp/policies/store/user-policies-store.service';
import { IPolicyRow } from '@webapp/policies/interfaces/policies.interface';
import { UsersStoreService } from '../../../store/users-store.service';
import { PaginationComponent } from '@webapp/core/ui/components/pagination/pagination.component';
import { PoliciesTableSkeletonComponent } from '@webapp/policies/ui/components/policies-table-skeleton/policies-table-skeleton.component';
import { PoliciesTableComponent } from '@webapp/policies/ui/components/policies-table/policies-table.component';

@Component({
  selector: 'app-user-policies',
  imports: [
    PaginationComponent,
    PoliciesTableComponent,
    PoliciesTableSkeletonComponent,
  ],
  templateUrl: './user-policies.component.html',
  styleUrl: './user-policies.component.scss',
})
export class UserPoliciesComponent implements OnInit {
  private store = inject(UserPoliciesStoreService);
  private userStore = inject(UsersStoreService);
  private authService = inject(AuthService);
  private router = inject(Router);

  showProducer = this.authService.isUserNotAgent();
  rows = this.store.getRows();
  paginationStore = this.store.listStore.paginationStore;
  loading = this.store.listStore.select('loading');

  ngOnInit() {
    this.changePage();
  }

  public changePage() {
    const filters = { client: { userId: this.userStore.get()()?.id } };

    if (Object.keys(filters).length) {
      this.store.listStore.set('filters', filters);
      this.store.listStore.fetch();
    }
  }

  openDetail(policy: IPolicyRow) {
    this.router.navigate(['polizas', policy.id]);
  }
}
